<template>
  <div class="base-container-aceites" v-if="abrirModal">
    <div class="modal-aceites">
      <button class="close-button" @click="closeModal" aria-label="Fechar modal">×</button>
      <div class="modal-aceites-content">
        <div v-for="aceite in aceitesFiltrados" :key="aceite.id">
          <h3>{{ aceite.nome }}</h3>
          <iframe
              :src="`${url_base.rota_docs_s3}/resource/documentos/${aceite.doc}`"
              width="100%"
              height="500px"
          ></iframe>
        </div>
      </div>
      <button class="botao botao-padrao" @click="closeModal">
        Fechar
      </button>
    </div>
  </div>
</template>


<script>
import mapaDeRotas from "@/router/caminho-urls";

export default {
  name: "ModalAceites",
  props: ["tipo_aceite", "abrirModal"],
  data() {
    return {
      aceites: [
        {id: 1, nome: "Termo de Uso", doc: "TermosDeUsoLjs.pdf"},
        {id: 2, nome: "Política de Privacidade", doc: "PrivacidadeLjs.pdf"},
        {id: 3, nome: "Termo de Adesão", doc: "TERMODEADESAOljs.pdf"},
      ],
      url_base: new mapaDeRotas(),
    };
  },
  computed: {
    aceitesFiltrados() {
      return this.aceites.filter((aceite) => aceite.id === this.tipo_aceite);
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:abrirModal", false);
    },
  },
};
</script>

<style scoped>
.base-container-aceites {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  padding: 10px;
}

.close-button {
  position: absolute;
  top: -40px;
  right: -110px;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #444;
  font-weight: bold;
  line-height: 1;
  z-index: 2;
}

.modal-aceites {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 800px;
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
}

.modal-aceites .modal-aceites-content h3 {
  text-align: center;
  color: #444;
}

.modal-aceites-content iframe {
  width: 100%;
  height: 500px;
  max-width: 100%;
  border: none;
}

@media (max-width: 768px) {
  .modal-aceites {
    max-width: 100%;
    padding: 15px;
  }

  .modal-aceites-content iframe {
    height: 300px;
  }
}

.modal-aceites button {
  padding: 10px;
  width: 250px;
  margin: 30px auto 0;
}

.botao-padrao {
  min-width: 60px;
  max-width: 150px;
}

</style>

  